import {EntitySelectComponent, ItemSelectComponent} from './item-select.component';
import { Component, forwardRef, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {PageResponse} from '../../models/page-response';
import {Company} from '../../models/company';
import {ProjectRelationService} from '../../services/project-relation.service';

@Component({
    selector: 'app-custom-company-select',
    templateUrl: './item-select.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CustomCompanySelectComponent),
            multi: true
        }
    ],
    standalone: false
})
export class CustomCompanySelectComponent extends ItemSelectComponent<Company, {}> {
    private projectRelationService = inject<ProjectRelationService>('ProjectRelationService' as any);

    constructor() {
        super();
    }

    addTag = (term: string) => ({companyName: term} as Company);

    getLabelText(item: Company): string {
        return item.companyName;
    }

    loadMorePages(page: number, filter: { term: string }): Observable<PageResponse<Company>> {
        return this.projectRelationService.listCustomCompanies(filter.term, page);
    }

    compare(a: Company, b: Company): boolean {
        if (!a || !b) {
            return false;
        }

        return a.companyName === b.companyName;
    }
}
